import React, { Component } from 'react';
import AOSalesView from './AOSalesView';
import css from './ApxView.module.css';
import cssMain from './Main.module.css';
import { AOModules } from '../Enums/Enums';
import DefaultView from './DefaultView';
import AOSupportView from './AOSupportView';
import VerticalNavigationAO from '../Components/VerticalNavigationAO';

class AOView extends Component {
  constructor(props) {
    super(props);

    this.props.data.AOModuleCallback = this.verticalMenuChange.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.navigationHasItems = false;
    this.currentview = AOModules.Default;

    this.state = {
      moduleView: AOModules.Default
    }
  }

  handleChangeValue(items) {
    this.navigationHasItems = items.length > 0;
    if (this.navigationHasItems)
      this.setState({ moduleView: items[0].value });
  }
  
  verticalMenuChange(value, index) {
    this.setState({ moduleView: value });
  }

  render() {
    return (
      <div style={{ width: "100%", height: "calc(100vh - 100px)" }}>
        <div className={css.vertical_menu}>
          <VerticalNavigationAO data={this.props.data} getItemList={this.handleChangeValue} items={[{ text: "Sales", value: "Sales", isActive: true }, { text: "Reports", value: "AOReports" },{ text: "Support", value: "AOSupport"} ]}></VerticalNavigationAO>
        </div>
       <div className={cssMain.scroll_area}>
          {(this.state.moduleView === AOModules.Default) ? <DefaultView></DefaultView> : null}
          {(this.state.moduleView === AOModules.Sales) ? <AOSalesView data={this.props.data}></AOSalesView> : null}
          {(this.state.moduleView === AOModules.Support) ? <AOSupportView data={this.props.data}></AOSupportView> : null}
        </div>
     </div>
    );
  }
}

export default AOView;